const product = [
  {
    id: 1,
    name: "Kiwi Berries(125g)",
    price: 559,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/kiwiberry_720x.jpg?v=1632830557",
    amount: 1,
  },
  {
    id: 2,
    name: "Papaya (1 Pc)",
    price: 59,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/Papaya-cover_540x.jpg?v=1632558426",
    amount: 1,
  },
  {
    id: 3,
    name: "Pink Guava(pack of 6)",
    price: 119,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/Pink-guava-cover_540x.jpg?v=1632551334",
    amount: 1,
  },
  {
    id: 4,
    name: "Dragon Fruit(1 pc)",
    price: 135,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/dragon-fruit--white-cover_540x.jpg?v=1632470660",
    amount: 1,
  },
  {
    id: 5,
    name: "Baby Pineapples(1 pc)",
    price: 569,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/PINEAPPLES-cover_540x.jpg?v=1632303320",
    amount: 1,
  },
  {
    id: 6,
    name: "Mini Oranges (6 pcs)",
    price: 136,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/Mini-Oranges-cover_540x.jpg?v=1631890350",
    amount: 1,
  },
  {
    id: 7,
    name: "Imported Oranges (Pack of 6) ",
    price: 259,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/a0cfceb5-76a4-4994-9d37-978c6dc3b309_540x.png?v=1614325971",
    amount: 1,
  },
  {
    id: 8,
    name: "Washington Apples (Pack of 4)",
    price: 283,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/Mangoes-safeda_540x.jpg?v=1649143538",
    amount: 1,
  },
  {
    id: 9,
    name: "Shimla Apples (Pack of 6)",
    price: 207,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/Shimla-Apples-cover_540x.jpg?v=1632485382",
    amount: 1,
  },
  {
    id: 10,
    name: "Globe Grapes-Golden kiwi Combo",
    price: 415,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/grapes-kiwicombo_540x.png?v=1630594918",
    amount: 1,
  },
  {
    id: 11,
    name: "Blueberries (125g)",
    price: 370,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/5e8b2ee6-ce8e-42e9-959f-d43c544f586a_540x.png?v=1620476121",
    amount: 1,
  },
  {
    id: 12,
    name: "Custard Apple",
    price: 239,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/Custard-Apple-A_540x.jpg?v=1632485537",
    amount: 1,
  },
  {
    id: 13,
    name: "Thai Guava",
    price: 79,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/CopyofGuava_Main_Clean_540x.png?v=1606828318",
    amount: 1,
  },
  {
    id: 14,
    name: "Banana Yelakki",
    price: 118,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/Yelakki-banana-cover_bc79dea2-08f8-404b-99f5-327a91213fbb_540x.jpg?v=1627026848",
    amount: 1,
  },
  {
    id: 15,
    name: "Avocado",
    price: 327,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/Avocado_540x.jpg?v=1622045769",
    amount: 1,
  },
  {
    id: 16,
    name: "Kiwis(3 pcs or 300g)",
    price: 145,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/1_6875ada8-f1e6-4589-b1fd-6f13a86b8ddb-min_900x.jpg?v=1614326173",
    amount: 1,
  },
  {
    id: 17,
    name: "Pear Beauty(Pack of 4)",
    price: 249,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/Pear-Beauty_540x.jpg?v=1626686136",
    amount: 1,
  },
  {
    id: 18,
    name: "Wholesome Combo",
    price: 970,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/Wholesome-combo_540x.jpg?v=1618497683",
    amount: 1,
  },
  {
    id: 19,
    name: "Pomegranate (Arils Cup)125g",
    price: 55,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/47dfb7d1-d8d3-4c96-bda9-7dc85dfdec51_540x.png?v=1614327841",
    amount: 1,
  },
  {
    id: 20,
    name: "Pomegranates(Pack of 4)",
    price: 275,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/221f2788-1a08-45ae-bdaf-7432d7ea0156_900x.png?v=1614326590",
    amount: 1,
  },
  {
    id: 21,
    name: "Bananas Robusta",
    price: 44,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/1_3311b3de-1a38-4175-8e8c-ac9577ec85df-min_540x.jpg?v=1614324773",
    amount: 1,
  },
  {
    id: 22,
    name: "Mosambi (Pack of 6)",
    price: 78,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/CopyofMosambi_Main_FixedShadows-min_900x.png?v=1614327085",
    amount: 1,
  },
  {
    id: 23,
    name: "Coconut Chunks Cup(100g)",
    price: 51,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/24d0f9c9-fe83-40a3-84ab-300e73e4ff8d_540x.png?v=1614323549",
    amount: 1,
  },
  {
    id: 24,
    name: "Grated Coconut Punnet",
    price: 51,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/0fce7fd6-f30e-45df-8c52-234acbd62023_540x.png?v=1614324324",
    amount: 1,
  },
  {
    id: 25,
    name: "Fruit Box(Strength)",
    price: 1700,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/2I8A7790_540x.jpg?v=1631346990",
    amount: 1,
  },
  {
    id: 26,
    name: "Fruit Box(Cherish)",
    price: 1200,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/2I8A7821_540x.jpg?v=1631350656",
    amount: 1,
  },
  {
    id: 27,
    name: "Fruit Box (Adore)",
    price: 2100,
    img: "https://cdn.shopify.com/s/files/1/0449/5225/6667/products/2I8A7807_540x.jpg?v=1631347683",
    amount: 1,
  },
];

export default product;
